import React from 'react';
import { Search, Droplet, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
export function SpecialOffers() {
  const offers = [{
    title: 'Free Roof Inspection',
    description: 'Schedule your complimentary, no-obligation roof inspection today to catch issues early.',
    icon: Search
  }, {
    title: 'Free Gutter Cleaning',
    description: 'Get free gutter cleaning when you invest in a new gutter protection system.',
    icon: Droplet
  }, {
    title: '$100 Cash Referral',
    description: 'Refer a friend or neighbor and earn $100 cash when their project is complete.',
    icon: DollarSign
  }];
  return <section className="py-16 bg-brand-blue" data-id="element-442">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-443">
        <div className="text-center mb-12" data-id="element-444">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4" data-id="element-445">
            Current Special Offers
          </h2>
          <p className="font-body text-blue-100 text-lg max-w-2xl mx-auto" data-id="element-446">
            Take advantage of these limited-time deals to protect your home and
            save money.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-447">
          {offers.map((offer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-xl p-6 shadow-xl flex flex-col items-center text-center border-l-4 border-brand-gray-dark" data-id="element-448">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4" data-id="element-449">
                <offer.icon size={32} className="text-brand-blue" data-id="element-450" />
              </div>
              <h3 className="font-heading font-bold text-xl text-brand-gray-dark mb-3" data-id="element-451">
                {offer.title}
              </h3>
              <p className="font-body text-brand-gray mb-6 flex-grow" data-id="element-452">
                {offer.description}
              </p>
              <a href="#quote" className="text-brand-blue font-body font-bold hover:text-brand-blue-dark transition-colors" data-id="element-453">
                Claim Offer &rarr;
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}